import { axios, handleError } from '../axios';

export const deleteAllPost = (data) => {
  return new Promise((resolve) => {
    const formData = new FormData();
    let url = '';

    if (data.category) {
      url = 'admin/post/delete/all';
      formData.append('category', data.category);
    } else if (data.gCategory) {
      url = 'admin/post/delete/allGalley';
      formData.append('gCategory', data.gCategory);
    } else {
      return false;
    }

    axios
      .post(url, formData)
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
